var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image 18 (traced)",
    clipPath: "url(#clip0_109_366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2734 1.0173C11.2148 1.0337 10.2867 1.38761 9.21094 1.80011C8.13516 2.21261 5.78906 3.11027 3.99609 3.79698C2.20312 4.4837 0.649219 5.07902 0.539062 5.12355C0.16875 5.27355 0 5.42823 0 5.62511C0 5.75167 0.0585937 5.8337 0.210937 5.91573C0.314062 5.97198 3.03984 6.83917 3.14062 6.84855C3.15937 6.85089 4.60078 5.96027 6.34453 4.86808C8.08594 3.77823 9.54609 2.86886 9.58828 2.84542C9.68203 2.79855 9.82969 2.78917 9.87187 2.83136C9.89531 2.8548 9.89297 2.8712 9.86719 2.91574C9.84844 2.9462 8.67656 4.00792 7.26562 5.27355L4.69922 7.57745L4.61484 8.76339C4.56797 9.41495 4.52109 10.0478 4.51406 10.165L4.49766 10.3829H4.60078C4.78828 10.3829 4.89844 10.2962 5.66953 9.55792L6.39609 8.86183L7.78594 9.87902C8.70234 10.5517 9.22031 10.915 9.30469 10.9501C9.38906 10.9829 9.4875 11.0017 9.58594 11.0017C9.83203 11.004 9.97734 10.8962 10.0992 10.6173C10.1227 10.5587 10.5633 8.55011 11.0742 6.15245C11.9906 1.85402 12.0047 1.79074 11.9953 1.56808C11.9883 1.36652 11.9789 1.32902 11.9156 1.22823C11.7914 1.02667 11.5289 0.939953 11.2734 1.0173Z",
    fill: "#FBBE08"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c7f1393e38c8380886a54df3fe9c4067.svg";
export { ForwardRef as ReactComponent };